// extracted by mini-css-extract-plugin
export default {"Subpage":"subPageLayout_Subpage__5RI3S","TopFivePatternsContainer":"subPageLayout_TopFivePatternsContainer__v7Xa5"};